import { Helmet } from "react-helmet-async";

/**
 * Setzt `<meta name="robots" content="noindex, follow">` auf allen Hosts,
 * die nicht die kanonische Produktiv-Domain `nxtinvoice.de` sind.
 * Verhindert Duplicate-Content-Indexing der Lovable-Vorschau-Domains.
 * Optional: per Prop force-noindex (z. B. Rechtsseiten).
 */
export default function SeoRobots({ noindex = false }: { noindex?: boolean }) {
  const host = typeof window !== "undefined" ? window.location.hostname : "nxtinvoice.de";
  const isCanonicalHost = host === "nxtinvoice.de" || host === "www.nxtinvoice.de";
  const shouldNoindex = noindex || !isCanonicalHost;
  return (
    <Helmet>
      <meta
        name="robots"
        content={shouldNoindex ? "noindex, follow" : "index, follow"}
      />
    </Helmet>
  );
}